import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function VolumeOff({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>VolumeOff</title>
      <path
        d="M5 5L19 19"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.37715 6.93762L6.80539 8.19503C6.76106 8.23049 6.70599 8.24981 6.64922 8.24981H4C3.0335 8.24981 2.25 9.03331 2.25 9.99981V13.9998C2.25 14.9663 3.0335 15.7498 4 15.7498H6.64922C6.70599 15.7498 6.76106 15.7691 6.80539 15.8046L9.90678 18.2857C11.0526 19.2024 12.75 18.3866 12.75 16.9192V11.3105L11.25 9.81047V16.9192C11.25 17.1288 11.0075 17.2454 10.8438 17.1144L7.74244 14.6333C7.43214 14.3851 7.04659 14.2498 6.64922 14.2498H4C3.86193 14.2498 3.75 14.1379 3.75 13.9998V9.99981C3.75 9.86174 3.86193 9.74981 4 9.74981H6.64922C7.04659 9.74981 7.43214 9.61457 7.74244 9.36633L9.44434 8.00481L8.37715 6.93762ZM11.25 7.68915V7.08043C11.25 6.87081 11.0075 6.75426 10.8438 6.88522L10.6228 7.062L9.55566 5.99481L9.90678 5.71391C11.0526 4.79725 12.75 5.61305 12.75 7.08043V9.18915L11.25 7.68915ZM15.6374 14.1979C15.5247 14.3845 15.3972 14.563 15.2557 14.7317C14.9894 15.049 15.0308 15.522 15.3481 15.7883C15.6654 16.0545 16.1385 16.0131 16.4048 15.6958C16.5169 15.5622 16.6224 15.4241 16.7213 15.2818L15.6374 14.1979ZM17.4357 13.8748L16.2014 12.6406C16.2255 12.483 16.2407 12.3235 16.2469 12.163C16.2831 11.2205 16.0047 10.2927 15.4557 9.52579C15.2146 9.18899 15.2921 8.72049 15.6289 8.47937C15.9657 8.23825 16.4342 8.31581 16.6753 8.6526C17.4182 9.69019 17.7947 10.9454 17.7458 12.2205C17.724 12.788 17.6184 13.3451 17.4357 13.8748ZM18.5087 17.0692C18.4473 17.1481 18.3843 17.226 18.3199 17.3028C18.0536 17.6201 18.095 18.0932 18.4123 18.3594C18.7296 18.6257 19.2027 18.5843 19.4689 18.267C19.5051 18.2239 19.5409 18.1805 19.5763 18.1368L18.5087 17.0692ZM20.4408 16.8799L19.3357 15.7748C19.9238 14.632 20.2407 13.3596 20.2498 12.0574C20.2632 10.1376 19.6067 8.27331 18.3933 6.78557C18.1315 6.46458 18.1795 5.99213 18.5005 5.73034C18.8215 5.46854 19.2939 5.51653 19.5557 5.83753C20.9897 7.59577 21.7656 9.79907 21.7498 12.0679C21.7379 13.7678 21.2821 15.4248 20.4408 16.8799Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
